// Logoen til en avtale (klubb, bedrift …) i Avtaleoversikt og på avtalen.
// Uten logo vises forbokstavene i navnet, så kortene står likt.
import React from "react";

const STORRELSER = {
  liten: "h-16 w-24 text-base",
  stor: "h-24 w-36 text-2xl",
};

const forbokstaver = (navn) =>
  String(navn || "")
    .split(/[\s-]+/)
    .filter((ord) => /^[\p{L}\d]/u.test(ord))
    .slice(0, 2)
    .map((ord) => ord[0].toUpperCase())
    .join("");

// Cloudinary skalerer logoen ned (noen er flere hundre kB), og andre adresser brukes som de er.
const skalert = (url) =>
  /^https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\//.test(url)
    ? url.replace("/image/upload/", "/image/upload/c_fit,w_240,h_240,f_auto,q_auto/")
    : url;

export default function AvtaleLogo({ agreement, storrelse = "liten" }) {
  const boks = `${STORRELSER[storrelse]} shrink-0 rounded-lg border border-gray-200 bg-white flex items-center justify-center overflow-hidden`;
  if (agreement.logo?.url) {
    return (
      <span className={boks}>
        <img src={skalert(agreement.logo.url)} alt={`Logo: ${agreement.name}`} className="h-full w-full object-contain p-1" loading="lazy" />
      </span>
    );
  }
  return (
    <span className={`${boks} bg-indigo-50 font-semibold text-indigo-700`} aria-hidden="true">
      {forbokstaver(agreement.name)}
    </span>
  );
}
